import React from "react";
import { Layout, Avatar, Typography, Space, Dropdown, Menu } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useAuth } from "../context/AuthContext";

const { Header: AntHeader } = Layout;
const { Text } = Typography;

export default function Header({ userImage, isOpen, selectedMenu }) {
  
  const { userName, logout } = useAuth();
  // ✅ Logout Logic
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiry");
    // Force redirect to login page
    window.location.href = "/login";
  };

  // ✅ The menu that appears inside the dropdown
  const menu = (
    <Menu style={{ width: 150 }}>
      <Menu.Item key="userName" disabled>
        <Text strong>{userName}</Text>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item 
        key="logout" 
        icon={<LogoutOutlined />} 
        onClick={handleLogout}
        danger // Makes the text red
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <AntHeader
      style={{
        position: "fixed",
        top: 0,
        left: isOpen ? 220 : 64,
        width: `calc(100% - ${isOpen ? 220 : 64}px)`,
        background: "#163968",
        padding: "0 16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        zIndex: 99,
        transition: "all 0.2s ease"
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        {selectedMenu && (
          <Text strong style={{ fontSize: 18, color: "white", whiteSpace: "nowrap" }}>
            {selectedMenu === "CRM" ? "Leads" : selectedMenu}
          </Text>
        )}
      </div>
      
      {/* ✅ Dropdown added here */}
      <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
        <Space align="center" style={{ cursor: "pointer" }}>
          <Text strong style={{ color: "white" }}>{userName ? `Hi, ${userName}` : "Hi!"}</Text>
          {userImage ? (
            <Avatar src={userImage} />
          ) : (
            <Avatar icon={<UserOutlined />} />
          )}
        </Space>
      </Dropdown>
    </AntHeader>
  );
}